import React from 'react';
import cn from '@/utils/cn';
import { iconVariant, TIconColor } from './iconVariant';
import { IconProps } from './types/IconInterface';

interface HomeProps extends IconProps {
  color?: TIconColor;
}

const Home = ({ size, variant, className, color = 'white' }: HomeProps) => (
  <svg
    className={cn(iconVariant({ size, variant, iconColor: color, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16">
    <path
      d="M7.64645 2.56051C7.84171 2.36525 8.15829 2.36525 8.35355 2.56051L14.1464 8.3534C14.3417 8.54866 14.6583 8.54866 14.8536 8.3534C15.0488 8.15814 15.0488 7.84156 14.8536 7.6463L9.06066 1.8534C8.47487 1.26762 7.52513 1.26762 6.93934 1.8534L1.14645 7.6463C0.951184 7.84156 0.951184 8.15814 1.14645 8.3534C1.34171 8.54866 1.65829 8.54866 1.85355 8.3534L7.64645 2.56051Z"
      fill="currentColor"
    />
    <path
      d="M8 3.62117L13.4393 9.06051C13.4592 9.08032 13.4794 9.09947 13.5 9.11794V13.2498C13.5 13.9402 12.9404 14.4998 12.25 14.4998H10C9.72386 14.4998 9.5 14.276 9.5 13.9998V10.9998C9.5 10.7237 9.27614 10.4998 9 10.4998H7C6.72386 10.4998 6.5 10.7237 6.5 10.9998V13.9998C6.5 14.276 6.27614 14.4998 6 14.4998H3.75C3.05964 14.4998 2.5 13.9402 2.5 13.2498V9.11794C2.52062 9.09947 2.54085 9.08032 2.56066 9.06051L8 3.62117Z"
      fill="currentColor"
    />
  </svg>
);

export default Home;
